import { render } from "./collegestudentsProcessed.vue?vue&type=template&id=113d4441&scoped=true"
import script from "./collegestudentsProcessed.vue?vue&type=script&lang=js"
export * from "./collegestudentsProcessed.vue?vue&type=script&lang=js"

import "./collegestudentsProcessed.vue?vue&type=style&index=0&id=113d4441&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113d4441"]])

export default __exports__